import { Select } from "antd";
import { useRef } from "react";
import { removeDiacritics } from "shared/helpers/remove-diacritics";

interface CountryOption {
  value: string;
  label: string;
}

export const filterOptionDiacritics: any = (
  input: string,
  option: CountryOption
) => {
  const normalizedInput = removeDiacritics(input?.toLowerCase());
  const normalizedOptionLabel = removeDiacritics(option.label?.toLowerCase());
  return normalizedOptionLabel.includes(normalizedInput);
};

const SingleMultiselect: React.FC<any> = (props) => {
  const { onChange, mode = "multiple" } = props;
  const selectRef = useRef<any>(null);

  const handleChange = (value: any) => {
    if (value?.length > 1) {
      onChange(value.slice(1));
    } else {
      onChange(value);
    }

    // Fecha o dropdown após a seleção usando blur()
    if (selectRef.current) {
      selectRef.current.blur();
    }
  };

  return (
    <Select
      {...props}
      ref={selectRef}
      mode={mode}
      filterOption={filterOptionDiacritics}
      onChange={handleChange}
      className={`${props.className || ""} notranslate`}
      classNames={{ popup: `notranslate ${props.dropdownClassName || ""}` }}
      popupRender={(menu) => (
        <div translate="no" className="notranslate">
          {menu}
        </div>
      )}
    />
  );
};
export default SingleMultiselect;
